import axios from "axios";
import { auth } from "../firebase";
import { captureException } from "@sentry/react";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
const BUNNY_ACCESS_KEY = import.meta.env.VITE_BUNNYNET_ACCESS_KEY;
const BUNNY_BASE_URL = import.meta.env.VITE_BUNNYNET_BASE_URL;
const BUNNY_LIBRARY_ID = import.meta.env.VITE_BUNNYNET_LIBRARY_ID;

const http = axios.create({
  baseURL: BACKEND_URL,
});

http.interceptors.request.use(async (config) => {
  try {
    if (!auth.currentUser) {
      console.error("No user signed in");
      return config;
    }

    const token = await auth.currentUser.getIdToken(true); // Force refresh

    config.headers.set("Authorization", `Bearer ${token}`);
    config.headers.set("x-bb-application", "web-qr");
    return config;
  } catch (error) {
    console.error("Error getting token", error);
    captureException(error);
    return config;
  }
});

const httpBunny = axios.create({
  baseURL: `${BUNNY_BASE_URL}/library/${BUNNY_LIBRARY_ID}`,
  headers: {
    accept: "application/json",
    AccessKey: BUNNY_ACCESS_KEY,
  },
});

export default http;
export { httpBunny };
